import { render, staticRenderFns } from "./routingrulesedit.vue?vue&type=template&id=6e4bbd5e"
import script from "./routingrulesedit.vue?vue&type=script&lang=js"
export * from "./routingrulesedit.vue?vue&type=script&lang=js"
import style0 from "./routingrulesedit.vue?vue&type=style&index=0&id=6e4bbd5e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports